module.exports = __webpack_public_path__ + "img/public/SiteIcons/hostStepIcons/location.svg?68cb18a3";